import React from 'react';
import { Heart, Shield, Award, Smile } from 'lucide-react';

const AnalysisConfidence = ({ confianzaAnalisis }) => {
  // Simplificamos la lógica de confianza
  const confidence = parseInt(confianzaAnalisis) || 80;
  const isHighConfidence = confidence >= 85;
  
  // Configuración visual basada en la confianza
  const config = {
    gradient: isHighConfidence ? 'from-emerald-50 to-emerald-100' : 'from-amber-50 to-amber-100',
    textColor: isHighConfidence ? 'text-emerald-700' : 'text-amber-700',
    iconColor: isHighConfidence ? 'text-emerald-500' : 'text-amber-500',
    bgAccent: isHighConfidence ? 'bg-emerald-100' : 'bg-amber-100',
    icon: isHighConfidence ? <Award className="h-4 w-4" /> : <Shield className="h-4 w-4" />,
    emoji: isHighConfidence ? '🐾' : '🦴'
  };

  return (
    <div className={`bg-gradient-to-r ${config.gradient} p-4 rounded-xl border border-gray-100 shadow-sm relative overflow-hidden group`}>
      {/* Patrón de fondo con huellas o huesos */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <span 
            key={i} 
            className="absolute text-black"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              fontSize: `${Math.random() * 10 + 12}px`,
              transform: `rotate(${Math.random() * 360}deg)`
            }}
          >
            {config.emoji}
          </span>
        ))}
      </div>
      
      <div className="flex items-start gap-3 relative">
        {/* Icono principal */}
        <div className={`${config.bgAccent} ${config.iconColor} p-2.5 rounded-full flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform`}>
          <Heart className="h-5 w-5" />
        </div>
        
        <div className="flex-1">
          {/* Título con badge integrado */}
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <h3 className={`font-semibold text-base ${config.textColor}`}>
              ¿Cómo está tu mascota?
            </h3>
            
            {confianzaAnalisis && (
              <div className={`px-2 py-0.5 rounded-full ${config.bgAccent}/70 ${config.textColor} text-xs font-medium flex items-center gap-1`}>
                {config.icon}
                <span>{confidence}% precisión</span>
              </div>
            )}
          </div>
          
          {/* Barra de progreso con emoji */}
          <div className="mt-2 h-2 bg-white/50 rounded-full overflow-hidden relative">
            <div 
              className={`h-full ${config.bgAccent} transition-all duration-1000 ease-out`}
              style={{ width: `${confidence}%` }}
            >
              <span 
                className="absolute -right-1 -top-1 text-xs animate-pulse"
                style={{ transform: 'translateY(-50%)' }}
              >
                {isHighConfidence ? '🐶' : '🐕'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisConfidence;